export class Modal {
    constructor(modalId) {
        this.modal = document.querySelector(modalId);
        if (this.modal == null) {
            return;
        }

        this.overlay = document.querySelector('#modal_overlay');

        // Если оверлей еще не создан, добавляем его в body
        if (this.overlay == null) {
            this.overlay = document.createElement('div');
            this.overlay.className = 'modal-overlay hidden fixed inset-0 bg-[#20202E] bg-opacity-60';
            this.overlay.id = 'modal_overlay';
            document.body.appendChild(this.overlay);
        }

        this.modalClose = this.modal.querySelector('.modal-close-m');

        // Закрытие модального окна по кнопке
        if (this.modalClose) {
            this.modalClose.addEventListener('click', this.closeModal.bind(this));
        }

        // Закрытие по клику на оверлей
        this.overlay.addEventListener('click', this.closeModal.bind(this));
    }

    openModal() {
        this.modal.classList.remove('hidden');
        this.overlay.classList.remove('hidden');
        this.overlay.classList.add('active')
        // setTimeout(() => this.overlay.classList.add('active'), 10); // Плавное появление оверлея
    }

    closeModal() {
        this.modal.classList.add('hidden');
        this.overlay.classList.remove('active');
        this.overlay.classList.add('hidden')
        // setTimeout(() => this.overlay.classList.add('hidden'), 300); // Плавное скрытие оверлея
    }

    static openModal(modalId) {
        const modalInstance = new Modal(modalId);
        modalInstance.openModal();
    }

    static closeModal(modalId) {
        const modalInstance = new Modal(modalId);
        modalInstance.closeModal();
    }

    static openNotificationModal(title, content, callback = null) {
        // Закрываем активное уведомление, если оно существует
        Modal.closeActiveNotification();

        // Создаем или получаем модальное окно уведомлений
        let notificationModal = document.querySelector('#notification-modal');
        if (!notificationModal) {
            notificationModal = Modal.createNotificationModal();
        }

        // Обновляем заголовок и текст
        notificationModal.querySelector('#notification-title').textContent = title;
        notificationModal.querySelector('#notification-message').textContent = content;

        // Добавляем слушатель закрытия
        const modalInstance = new Modal('#notification-modal');
        if (callback && typeof callback === 'function') {
            modalInstance.modalClose.addEventListener('click', callback);
        }

        // Открываем модальное окно уведомления
        modalInstance.openModal();
    }

    static createNotificationModal() {
        const modalHtml = `
            <div class="modal m-0 bg-white fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center w-[95%] md:w-[400px] p-6 rounded-3xl hidden" id="notification-modal">
                <div class="modal-close-m absolute top-6 right-6 cursor-pointer">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M15.7068 1.70723C16.0974 1.3167 16.0974 0.68354 15.7068 0.293015C15.3163 -0.097509 14.6832 -0.097509 14.2926 0.293015L7.99986 6.58579L1.70711 0.29303C1.31658 -0.0974937 0.683419 -0.0974941 0.292894 0.29303C-0.09763 0.683554 -0.0976297 1.31672 0.292894 1.70724L6.58565 8L0.292893 14.2928C-0.0976308 14.6833 -0.0976312 15.3164 0.292893 15.707C0.683417 16.0975 1.31658 16.0975 1.70711 15.707L7.99986 9.41421L14.2926 15.707C14.6832 16.0975 15.3163 16.0975 15.7068 15.707C16.0974 15.3165 16.0974 14.6833 15.7068 14.2928L9.41408 8L15.7068 1.70723Z"
                              fill="#979797"/>
                    </svg>
                </div>
                
                <div class="modal-head">
                    <h3 id="notification-title" class="block w-full font-chalet font-bold text-2xl text-center mb-11 mx-auto"></h3>
                </div>
                
                <div class="modal-body">
                    <p id="notification-message" class="text-center text-[16px] leading-6"></p>
                </div>
            </div>
        `;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = modalHtml.trim();
        const modalElement = tempDiv.firstChild;
        document.body.appendChild(modalElement);
        return modalElement;
    }

    static closeActiveNotification() {
        const activeModal = document.querySelector('#notification-modal');
        if (activeModal && !activeModal.classList.contains('hidden')) {
            const modalInstance = new Modal('#notification-modal');
            modalInstance.closeModal();
        }
    }
}
